<section>
  <h2 class="heading-underline">Scripting</h2>
  @if (breadcrumbs.pathItems.length > 0) {
    <app-breadcrumbs [path]="breadcrumbs"> </app-breadcrumbs>
  }
  <table>
    <tr>
      <td><h4>Name</h4></td>
      <td><input type="text" [(ngModel)]="field.label" /></td>
    </tr>
    <tr>
      <td><h4>Path</h4></td>
      <td>
        <input #pathInput type="text" [placeholder]="pathPlaceHolder" (input)="onPathValueInput($event)" />
      </td>
    </tr>
    <tr class="absolute-path-hint-text">
      <td>&nbsp;</td>
      <td>
        {{ absolutePath.length > 0 ? absolutePath : 'Type to see full path' }}
      </td>
    </tr>
    <tr>
      <td><h4>Type</h4></td>
      <td>
        <mat-button-toggle-group
          style="display: flex; flex-wrap: wrap"
          name="outputType"
          aria-label="Output"
          [(ngModel)]="field.type"
          [hideSingleSelectionIndicator]="true"
          >
          <mat-button-toggle [value]="FieldType.STRING">String</mat-button-toggle>
          <mat-button-toggle [value]="FieldType.TO_ONE">Object</mat-button-toggle>
          <mat-button-toggle [value]="FieldType.TO_MANY">List</mat-button-toggle>
        </mat-button-toggle-group>
      </td>
    </tr>
    <tr>
      <td>&nbsp;</td>
      <td>
        <button
          style="min-height: 0"
          theme="medium"
          (click)="onInsertClick()"
          [disabled]="field.label.length === 0 || pathInput.value.length === 0 || absolutePath.length === 0"
          >
          INSERT
        </button>
      </td>
    </tr>
  </table>
</section>
